import * as angular from "angular";
import {IController} from "angular";

export class fulfillmentScheduleIndicationComponent implements IController {

  isScheduled: boolean;

  constructor() {
  }

  $onInit() {
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentScheduleIndication', {
    bindings: {
      isScheduled: '<'
    },
    template: require('./fulfillment-schedule-indication.html').default,
    controller: fulfillmentScheduleIndicationComponent
  });
